import { createContext } from 'react';

export interface CartItemsContext {
  numCartItems: number;
  setUpdatedNumCartItems: (cartItems: number) => void;
}

export const cartItemsContext = createContext<CartItemsContext>({
  numCartItems: 0,
  setUpdatedNumCartItems: () => {},
});
